<div *ngIf="isTab || isTabOverride">
  <ul class="d-flex nav-bar">
    <li *ngFor="let tab of apiTabs; let i = index" class="tab-link bgdgry"
      [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'"
      (click)="selectedIndex = i; setPageTitle(apiName + ' ' + tab)">
      <a class="nav-link active" data-bs-toggle="tab">
        <i [ngClass]="apiTabsClass[i]"></i>
        {{ tab }}</a>
    </li>
  </ul>
</div>
<!-- Tab panes -->
<div class="tab-content">
  <div class="slideme">
    <app-api-reference-overview-page [pageName]="pageTitle"
      *ngIf="pageTitle.includes('Overview')"></app-api-reference-overview-page>
    <app-api-reference-request-page [pageName]="pageTitle" [href]="href"
      *ngIf="pageTitle.includes('Request')"></app-api-reference-request-page>
    <app-api-reference-response-page [pageName]="pageTitle" [href]="href"
      *ngIf="pageTitle.includes('Response') && !pageTitle.includes('Error Responses')"></app-api-reference-response-page>
    <app-api-reference-xml-samples-page [pageName]="pageTitle" [href]="href"
      *ngIf="pageTitle.includes('XML Samples')"></app-api-reference-xml-samples-page>
    <app-api-reference-error-responses-page [pageName]="pageTitle"
      *ngIf="pageTitle.includes('Error Responses')"></app-api-reference-error-responses-page>
    <app-api-reference-registration-page [pageName]="pageTitle"
      *ngIf="pageTitle.includes('Registration')"></app-api-reference-registration-page>
  </div>
</div>